import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { photoService } from '../../services/api';
import { FiFolder, FiImage } from 'react-icons/fi';
import './EventAlbums.css';

const FamilyAlbums = () => {
  const [albums, setAlbums] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchAlbums();
  }, []);

  const fetchAlbums = async () => {
    try {
      setLoading(true);
      const response = await photoService.getAllMemberAlbums();
      if (response.success) {
        setAlbums(response.data);
      }
    } catch (err) {
      console.error('Failed to fetch albums:', err);
      setError('Failed to load albums');
    } finally {
      setLoading(false);
    }
  };

  // Group albums by member
  const groupedByMember = Object.values(
    albums.reduce((groups, album) => {
      const key = album.memberID;
      if (!groups[key]) groups[key] = { member: album.member, albums: [] };
      groups[key].albums.push(album);
      return groups;
    }, {})
  ).sort((a, b) => {
    const nameA = `${a.member?.firstName || ''} ${a.member?.lastName || ''}`.toLowerCase();
    const nameB = `${b.member?.firstName || ''} ${b.member?.lastName || ''}`.toLowerCase();
    return nameA.localeCompare(nameB);
  });

  return (
    <div className="event-albums-page">
      <div className="container">
        <div className="page-header">
          <h1><FiImage className="page-header-icon" /> Family Albums</h1>
          <p className="page-subtitle">Browse everyone's photo albums</p>
        </div>

        {loading ? (
          <div className="loading-state">
            <span className="spinner spinner-lg"></span>
            <p>Loading albums...</p>
          </div>
        ) : error ? (
          <div className="error-state card">
            <p>{error}</p>
            <button className="btn btn-primary" onClick={fetchAlbums}>Try Again</button>
          </div>
        ) : groupedByMember.length === 0 ? (
          <div className="empty-state card">
            <div className="empty-state-icon">📁</div>
            <h3 className="empty-state-title">No Albums Yet</h3>
            <p>When family members create photo albums they'll appear here.</p>
          </div>
        ) : (
          groupedByMember.map(group => (
            <section key={group.member?.memberID} className="event-albums-section">
              <h2 className="event-albums-section-title">
                <Link to={`/member/${group.member?.memberID}`} className="family-albums-member-link">
                  {group.member?.fullName}
                </Link>
              </h2>
              <div className="event-albums-grid">
                {group.albums.map(album => (
                  <Link
                    key={album.albumID}
                    to={`/photos/album/${album.albumID}`}
                    state={{ from: 'family-albums' }}
                    className="event-album-card card"
                  >
                    <div className="event-album-cover">
                      {album.coverPhotoURL ? (
                        <img src={album.coverPhotoURL} alt={album.albumName} />
                      ) : (
                        <div className="event-album-placeholder">
                          <FiFolder />
                        </div>
                      )}
                    </div>
                    <div className="event-album-info">
                      <h3 className="event-album-name">{album.albumName}</h3>
                      <p className="event-album-count">{album.photoCount} photos</p>
                    </div>
                  </Link>
                ))}
              </div>
            </section>
          ))
        )}
      </div>
    </div>
  );
};

export default FamilyAlbums;